exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#activeFlights[data-v-e2ae5f4e]{font-family:Inter,sans-serif!important;font-size:.8rem}.card .card-title[data-v-e2ae5f4e]{text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e2ae5f4e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/ActiveFlights.vue
// module id = 488
// module chunks = 0